import { ProductsLayout } from './components/ProductsLayout';
import { ProductsPage } from './components/list/ProductsPage';
import { ProductDetailPage } from './components/detail/ProductDetailPage';
import { ProductDashboard } from './components/dashboard/ProductDashboard';

export const productsRoutes = {
  element: <ProductsLayout />,
  children: [
    {
      index: true,
      element: <ProductsPage />
    },
    {
      path: 'dashboard',
      element: <ProductDashboard />
    },
    {
      path: ':id',
      element: <ProductDetailPage />
    }
  ]
}; 